import { observable, computed, action, useStrict, runInAction } from "mobx";
useStrict(true);

class BaseStore {
  @action.bound
  update(k, v) {
    if (typeof k === "string") {
      this[k] = v;
    } else {
      Object.assign(this, k);
    }
  }
}

export default BaseStore;



// WEBPACK FOOTER //
// ./src/store/BaseStore.js